import { Button } from 'antd';
import { ChatMessage } from '../../domain/models';
import ChatMessageBubble from './ChatMessageBubble';
import styles from './Chat.module.scss';

export interface ChatMessagesListProps {
  messages: ChatMessage[];
  sending: boolean;
  aiFailed: boolean;
  retryPrompt: string | null;
  onRetry: () => void;
  bottomRef: React.RefObject<HTMLDivElement | null>;
  tenantId?: string;
  threadId?: string;
}

const ChatMessagesList = ({
  messages,
  sending,
  aiFailed,
  retryPrompt,
  onRetry,
  bottomRef,
  tenantId,
  threadId,
}: ChatMessagesListProps) => {
  return (
    <>
      {messages.map((message, idx) => (
        <ChatMessageBubble
          key={message.id}
          id={message.id}
          role={message.role}
          content={message.content}
          isLatest={idx === messages.length - 1}
          isSending={sending}
          attachments={message.attachments}
          tenantId={tenantId}
          threadId={threadId}
        />
      ))}

      {aiFailed && retryPrompt && (
        <div className={styles.retryContainer}>
          <Button size="small" onClick={onRetry} disabled={sending}>
            Retry AI Response
          </Button>
        </div>
      )}

      <div ref={bottomRef} />
    </>
  );
};

export default ChatMessagesList;
